import * as actions from '@actions'
import { CHECK_DETAIL_FIELDS } from '@constants'
import { toast } from 'react-toastify'

// import cn from 'clsx'

import Checkbox from '$components/Forms/Checkbox'
import ContentEditable from '@components/contenteditable'
import { MdDelete } from 'react-icons/md'

// @todo disabled for now bc textareas get cut off?
const multilineFields = [
    // 'btu',
]

const CheckDetailsEditRow = ({
    details,
    hasChecked,
    toggleChecked,
}) => {
    
    const deleteDetailsRow = async () => {
        
        try {
            
            toast.warn('Not yet implemented')
            
            // @todo
            await actions.fetchChecks()
            
            // toast.success('Check details deleted')
            
        } catch (e) {
            
            console.error('deleteDetailsRow', e)
            
            toast.error('Failed to delete check details')
            
        }
        
    }
    
    return (
        
        <tr className="CheckDetailsEditRow">
            
            <td className="w-2 px-2">
                <Checkbox
                    checked={hasChecked(details.id)}
                    onChange={() => toggleChecked(details.id)} />
            </td>
            
            {Object.values(CHECK_DETAIL_FIELDS).map(it => (
                <td
                    key={it}>
                    <ContentEditable
                        type={multilineFields.includes(it) ? 'textarea' : 'text'}
                        placeholder=""
                        value={details?.[it] ?? ''}
                        onEditEnd={(...args) => console.log('editable', [args])} />
                </td>
            ))}
            
            <td>
                <div className="flex items-center content-center justify-center gap-4">
                    <button
                        className="btn"
                        onClick={deleteDetailsRow}>
                        <MdDelete />
                    </button>
                </div>
            </td>
        
        </tr>
        
    )
    
}

export default CheckDetailsEditRow
